import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { Constants } from '../../shared/models/constants';
import { Enums } from '../../shared/models/enums';
import { CellRendererElementTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element.enum';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';
import { CellRendererElementSubTypes } from '../../shared/widgets/data-grid/enums/cell-renderer-element-Subtype.enum';

@Injectable()
export class EdgeExpertsDirectoryGridService {
    constructor() { }
    ;
    projectNameCellRenderer(rowData) {
        return rowData.unreadNotification ? `<span class="grid-cell-notification me-1"><i class="fas fa-circle text-buttercup"></i></span>` : '';
    }
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    private callbackProjDOcUploadModalClose = new Subject<any>(); // Source
    eventCallbackProjDocuUploadModalClose$ = this.callbackProjDOcUploadModalClose.asObservable(); // Stream

    cols: Array<TableColumn> = [
        {
            field: 'emailID',
            header: 'EDGE Account Email',
            sort: true,
            sortName: 'EmailID',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onExpertEmailClick',
                renderEventBeforeHtml: this.projectNameCellRenderer
            }
        },
        {
            field: 'firstName',
            header: 'First Name',
            sort: true,
            sortName: 'FirstName',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'lastName',
            header: 'Last Name',
            sort: true,
            sortName: 'LastName',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'epin',
            header: 'EPIN',
            sort: true,
            sortName: 'epin',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'primaryEmail',
            header: 'EDGE Applicant Email',
            pinned: false,
            sort: true,
            sortName: 'PrimaryEmail',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'alternateEmail',
            header: 'Alternate Email(s)',
            pinned: false,
            sort: true,
            sortName: 'AlternateEmail',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'edgeExpertCertWebEmail',
            header: 'EDGE Expert Email',
            sort: true,
            sortName: 'EdgeExpertCertWebEmail',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'licenseDate',
            header: 'Accreditation Date',
            sort: true,
            sortName: 'LicenseDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'licenseId',
            header: 'License Id',
            sort: true,
            sortName: 'LicenseId',
            filter: { type: FilterTypes.text }
        },  
        {
            field: 'country',
            header: 'Country',
            sort: true,
            sortName: 'Country',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'city',
            header: 'City',
            sort: true,
            sortName: 'City',
            filter: { type: FilterTypes.text }
        },

        {
            field: 'roleName',
            header: 'Job Title',
            sort: true,
            sortName: 'RoleName',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'partnerName',
            header: 'Training Partner',
            sort: true,
            sortName: 'PartnerName',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'CAMACOL', value: 'CAMACOL' },
                    { label: 'CEDBIK', value: 'CEDBIK' },
                    { label: 'GBC Costa Rica', value: 'GBC Costa Rica' },
                    { label: 'GBC Indonesia', value: 'GBC Indonesia' },
                    { label: 'GBC South Africa', value: 'GBC South Africa' },
                    { label: 'GBCI', value: 'GBCI' },
                    { label: 'IFC', value: 'IFC' },
                    { label: 'PGBI', value: 'PGBI' },
                    { label: 'SGS Vietnam', value: 'SGS Vietnam' },
                    { label: 'Sintali-SGS', value: 'Sintali-SGS' },
                    { label: 'Other', value: 'Other' }
                ]
            }
        },
        {
            field: 'edgeFaculty1',
            header: 'EDGE Faculty',
            sort: true,
            sortName: 'edgeFaculty1',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'edgeFaculty2',
            header: 'EDGE Second Faculty',
            sort: true,
            sortName: 'edgeFaculty2',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'projectCountUnderWorkFlow',
            header: 'Workflow Subprojects Count'
        }, {
            field: 'projectCountCertified',
            header: 'Certified Subprojects Count'
        },
        {
            field: 'lastActivity',
            header: 'Last Activity',
            sort: true,
            sortName: 'lastActivity',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        }
    ];

    cols_auditors : Array<TableColumn> = [
        {
            field: 'accountEmail',
            header: 'EDGE Account Email',
            sort: true,
            sortName: 'AccountEmail',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onAuditorExpertEmailClick',
                renderEventBeforeHtml: this.projectNameCellRenderer
            }
        },
        {
            field: 'firstName',
            header: 'First Name',
            sort: true,
            sortName: 'FirstName',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'lastName',
            header: 'Last Name',
            sort: true,
            sortName: 'LastName',
            filter: { type: FilterTypes.text },
        }, {
            field: 'gender',
            header: 'Gender',
            sort: true,
            sortName: 'Gender',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Female', value: 'Female' },
                    { label: 'Male', value: 'Male' },
                    { label: 'Other', value: 'Other' },
                    { label: 'Prefer not to answer', value: 'Prefer not to answer' }
                ]
            }
        },
        {
            field: 'epin',
            header: 'EPIN',
            sort: true,
            sortName: 'epin',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'country',
            header: 'Country',
            sort: true,
            sortName: 'Country',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'organization',
            header: 'Organization',
            sort: true,
            sortName: 'Organization',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'phoneCode',
            header: 'Phone Code',
            sort: true,
            sortName: 'PhoneCode',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'mobileNo',
            header: 'Mobile Number',
            sort: true,
            sortName: 'MobileNo',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'licenseId',
            header: 'License Id',
            sort: true,
            sortName: 'LicenseId',
            filter: { type: FilterTypes.text }
        }, 
        {
            field: 'issueDate',
            header: 'Auditor License Issue Date',
            sort: true,
            sortName: 'IssueDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'renewalDate',
            header: 'Auditor License Renew Date',
            sort: true,
            sortName: 'RenewalDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'expiryDate',
            header: 'Auditor License Expiry Date',
            sort: true,
            sortName: 'ExpiryDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'lastActivity',
            header: 'Last Activity',
            sort: true,
            sortName: 'lastActivity',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'isDownload',
            header: 'Download',
            displayName: ' ',
            isEnable: 'isDownload',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDownloadAuditorCertificate',
                elementsubType: CellRendererElementSubTypes.download,
            }
        }
    ];

    cols_superadmins: Array<TableColumn> = [
        {
            field: 'accountEmail',
            header: 'EDGE Account Email',
            sort: true,
            sortName: 'AccountEmail',
            filter: { type: FilterTypes.text }
            
        },
        {
            field: 'firstName',
            header: 'First Name',
            sort: true,
            sortName: 'FirstName',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'lastName',
            header: 'Last Name',
            sort: true,
            sortName: 'LastName',
            filter: { type: FilterTypes.text },
        }, {
            field: 'gender',
            header: 'Gender',
            sort: true,
            sortName: 'Gender',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Female', value: 'Female' },
                    { label: 'Male', value: 'Male' },
                    { label: 'Other', value: 'Other' },
                    { label: 'Prefer not to answer', value: 'Prefer not to answer' }
                ]
            }
        },
        {
            field: 'epin',
            header: 'EPIN',
            sort: true,
            sortName: 'epin',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'country',
            header: 'Country',
            sort: true,
            sortName: 'Country',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'organization',
            header: 'Organization',
            sort: true,
            sortName: 'Organization',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'phoneCode',
            header: 'Phone Code',
            sort: true,
            sortName: 'PhoneCode',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'mobileNo',
            header: 'Mobile Number',
            sort: true,
            sortName: 'MobileNo',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'licenseId',
            header: 'License Id',
            sort: true,
            sortName: 'LicenseId',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'issueDate',
            header: 'Auditor License Issue Date',
            sort: true,
            sortName: 'IssueDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'renewalDate',
            header: 'Auditor License Renew Date',
            sort: true,
            sortName: 'RenewalDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'expiryDate',
            header: 'Auditor License Expiry Date',
            sort: true,
            sortName: 'ExpiryDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'lastActivity',
            header: 'Last Activity',
            sort: true,
            sortName: 'lastActivity',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'isDownload',
            header: 'Download',
            displayName: ' ',
            isEnable: 'isDownload',
            cellRenderer: {
                type: CellRendererTypes.event,
                elementType: CellRendererElementTypes.anchor,
                eventName: 'onDownloadAuditorCertificate',
                elementsubType: CellRendererElementSubTypes.download,
            }
        }
    ];

    cols_common: Array<TableColumn> = [
        {
            field: 'emailID',
            header: 'EDGE Account Email',
            sort: true,
            sortName: 'EmailID',
            filter: { type: FilterTypes.text },
            
            
        },
        {
            field: 'firstName',
            header: 'First Name',
            sort: true,
            sortName: 'FirstName',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'lastName',
            header: 'Last Name',
            sort: true,
            sortName: 'LastName',
            filter: { type: FilterTypes.text },
        }, {
            field: 'gender',
            header: 'Gender',
            sort: true,
            sortName: 'Gender',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Female', value: 'Female' },
                    { label: 'Male', value: 'Male' },
                    { label: 'Other', value: 'Other' },
                    { label: 'Prefer not to answer', value: 'Prefer not to answer' }
                ]
            }
        },
        {
            field: 'epin',
            header: 'EPIN',
            sort: true,
            sortName: 'epin',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'primaryEmail',
            header: 'EDGE Applicant Email',
            pinned: false,
            sort: true,
            sortName: 'PrimaryEmail',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'alternateEmail',
            header: 'Alternate Email(s)',
            pinned: false,
            sort: true,
            sortName: 'AlternateEmail',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'edgeExpertCertWebEmail',
            header: 'EDGE Expert Email',
            sort: true,
            sortName: 'EdgeExpertCertWebEmail',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'licenseDate',
            header: 'Accreditation Date',
            sort: true,
            sortName: 'LicenseDate',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'licenseId',
            header: 'License Id',
            sort: true,
            sortName: 'LicenseId',
            filter: { type: FilterTypes.text }
        }, {
            field: 'country',
            header: 'Country',
            sort: true,
            sortName: 'Country',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'city',
            header: 'City',
            sort: true,
            sortName: 'City',
            filter: { type: FilterTypes.text }
        },

        {
            field: 'roleName',
            header: 'Job Title',
            sort: true,
            sortName: 'RoleName',
            filter: { type: FilterTypes.text }
        }, 
        {
            field: 'partnerName',
            header: 'Training Partner',
            sort: true,
            sortName: 'PartnerName',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'CAMACOL', value: 'CAMACOL' },
                    { label: 'CEDBIK', value: 'CEDBIK' },
                    { label: 'GBC Costa Rica', value: 'GBC Costa Rica' },
                    { label: 'GBC Indonesia', value: 'GBC Indonesia' },
                    { label: 'GBC South Africa', value: 'GBC South Africa' },
                    { label: 'GBCI', value: 'GBCI' },
                    { label: 'IFC', value: 'IFC' },
                    { label: 'PGBI', value: 'PGBI' },
                    { label: 'SGS Vietnam', value: 'SGS Vietnam' },
                    { label: 'Sintali-SGS', value: 'Sintali-SGS' },
                    { label: 'Other', value: 'Other' }
                ]
            }
        },
        {
            field: 'edgeFaculty1',
            header: 'EDGE Faculty',
            sort: true,
            sortName: 'edgeFaculty1',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'edgeFaculty2',
            header: 'EDGE Second Faculty',
            sort: true,
            sortName: 'edgeFaculty2',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'projectCountUnderWorkFlow',
            header: 'Workflow Subprojects Count'
        }, {
            field: 'projectCountCertified',
            header: 'Certified Subprojects Count'
        },
        {
            field: 'lastActivity',
            header: 'Last Activity',
            sort: true,
            sortName: 'lastActivity',
            filter: { type: FilterTypes.calender },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        }
    ];

    dateCellRenderer(rowData, field) {
        if (rowData[field]) {
            const value = formatDate(rowData[field], Constants.DATETIME_FORMAT, 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }
}

